<template>
    <div class="table-responsive">
    <table class="table table-hover no-overflow">
        <thead>
            <tr>
                <th @click="sortBy('loanApplication.loan_ReferenceNumber')">
                    Folio de Solicitudes
                    <span v-if="sortKey === 'loanApplication.loan_ReferenceNumber'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="sortBy('loanApplication.prospectus.prospectus_ReferenceNumber')">
                    Folio de Prospectos
                    <span v-if="sortKey === 'loanApplication.prospectus.prospectus_ReferenceNumber'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="sortBy('financialRecord.record_ReferenceNumber')">
                    Folio de Expedientes
                    <span v-if="sortKey === 'financialRecord.record_ReferenceNumber'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="sortBy('financialRecord.record_Name')">
                    Nombre de Expedientes
                    <span v-if="sortKey === 'financialRecord.record_Name'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="sortBy('financialRecord.recordType.recordType_Name')">
                    Tipo de Expedientes
                    <span v-if="sortKey === 'financialRecord.recordType.recordType_Name'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <!-- <th>Nombre de Prospectos</th> -->
                <!-- <th>Estatus</th> -->
                <th>Acciones</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="item in sortedData" :key="item.id" v-if="sortedData.length != 0">
                <td class="sorting_1 dtr-control"> {{ item.loanApplication.loan_ReferenceNumber }}</td>
                <td>{{ item.loanApplication.prospectus.prospectus_ReferenceNumber }}</td>
                <td>{{ item.financialRecord.record_ReferenceNumber }}</td>
                <td>{{ item.financialRecord.record_Name }}</td>
                <td>{{ item.financialRecord.recordType.recordType_Name }}</td>
                <!-- <td>{{ prospectusFullName(item.prospectus) }}</td>
                    <td>{{ item.status.name }}</td> -->
                <td>
                    <PrimaryButton class="btn-success" data-toggle="modal" data-target="#modal-lg"
                        @click.prevent="editItem(item)"><i class="fa fa-edit"></i>
                    </PrimaryButton>
                    <!-- <PrimaryButton class="btn-danger" @click.prevent="deleteItem(item)"><i class="fa fa-trash"></i>
                        </PrimaryButton> -->
                </td>
            </tr>
            <tr v-else>
                <td colspan="6" style="text-align: center;">{{ $getLocaleMessage('common', 'noDataFound') }}</td>
            </tr>
        </tbody>
    </table>
    </div>
</template>

<script>
import PrimaryButton from '@/Components/PrimaryButton.vue';

export default {
    components: { PrimaryButton },
    data() {
        return {
            sortKey: '',
            sortOrder: 1, // 1 for ascending, -1 for descending
        }
    },
    emits: ['edit-item', 'delete-item'],
    props: {
        list: {
            type: Array,
            default: () => { },
            required: true
        },
        itemsPerPage: {
            type: Number,
            default: () => 10,
        },
        currentPage: {
            type: Number,
            default: () => 1
        }
    },
    computed: {
        getCompanies() {
            return this.list;
        },
        sortedData() {
            let sortedList = [...this.list];
            if (this.sortKey) {
                sortedList.sort((a, b) => {

                    let aValue = this.getNestedValue(a, this.sortKey);
                    let bValue = this.getNestedValue(b, this.sortKey);


                    if (aValue < bValue) return -1 * this.sortOrder;
                    if (aValue > bValue) return 1 * this.sortOrder;
                    return 0;
                });
            }
            return this.paginate(sortedList);
        }
    },
    methods: {
        sortBy(key) {
            if (this.sortKey === key) {
                this.sortOrder *= -1; // Toggle the sort order
            } else {
                this.sortOrder = 1; // Reset to ascending if a new column is sorted
            }
            this.sortKey = key;
        },
        getNestedValue(obj, key) {
            return key.split('.').reduce((o, i) => o[i], obj);
        },
        paginate(list) {
            if (!list || list.length === 0) return [];
            let start = (this.currentPage * this.itemsPerPage) - this.itemsPerPage;
            return list.slice(start, start + this.itemsPerPage);
        },
        getDataPage() {
            let start = (this.currentPage * this.itemsPerPage) - this.itemsPerPage;
            let end = (this.currentPage * this.itemsPerPage);
            return this.list.slice(start, end);
        },
        editItem(item) {
            this.$emit('edit-item', item);
        },
        deleteItem(item) {
            this.$emit('delete-item', item);
        },
        prospectusFullName(prospectus) {
            const generalInfo = prospectus.generalInformation;
            if (prospectus.personTypeId == 1) {
                return `${generalInfo.firstName} ${generalInfo.lastName} ${generalInfo.mothersMaidenName}`;
            } else {
                return `${generalInfo.businessName}`;
            }
        }
    },
    created() {
        this.getDataPage();
    }
}
</script>